<template>
  <div class="limit">
    <span class="icon-root">
      <abacus-icon
        :size="18"
        v-if="rule.value === 'count'"
        :fillColor="iconFill"
      />
      <span v-else-if="rule.value ==='weight'" class="percentage">%</span>
      <delete-icon v-else :size="18" :fillColor="iconFill" />
    </span>
    <span class="rule">
      {{$t(`portfolioManager.ruleOptions.${rule.value}Short`)}}
    </span>
    <span :class="{ up: limit && limit.value === 'max' }" class="coloured" v-if="limit">
      {{limit.name}}
    </span>
    <img
      :src="value.icon"
      class="ticker-logo"
      v-else-if="value.icon !== ''"
      @error="hasLogo = false"
    />
    <gradient-icon class="ticker-logo" :ticker="value.ticker" v-else small/>
    <span
      :class="{ up: limit && limit.value === 'max' }"
      class="coloured body-bold value"
      >{{ `${ruleValue} ${rule.value === "weight" ? "%" : ""}` }}</span
    >
    <close-icon @click="removeRule(id)" :size="12" />
  </div>
</template>

<script>
import AbacusIcon from "vue-material-design-icons/Abacus";
import CloseIcon from "vue-material-design-icons/Close.vue";
import DeleteIcon from "vue-material-design-icons/DeleteOutline.vue";
import GradientIcon from "./GradientIcon.vue";
import { ICONS_FILL_COLOR } from "../utils/constants";
import { mapMutations } from "vuex";
export default {
  name: "limit",
  components: { CloseIcon, AbacusIcon, DeleteIcon, GradientIcon },
  props: {
    limit: Object,
    pool: Object,
    rule: Object,
    value: [Number, String, Object],
    id: String,
  },
  data() {
    return {
      iconFill: ICONS_FILL_COLOR,
    };
  },
  methods: {
    ...mapMutations("portfolioManagerStore", ["removeRule"]),
  },
  computed: {
    ruleValue(){
      if(this.rule.value === "tickers"){
        return this.value.ticker;
      }
      return this.value;
    }
  }
};
</script>

<style lang="scss" scoped>
.limit {
  @include limit-des;
  .close-icon {
    cursor: pointer;
  }
  .rule {
    text-transform: capitalize;
    width: toRem(49);
  }
  .coloured {
    color: #0a68ec;
    &.up {
      color: #e850a2;
    }
  }
  .percentage {
    font-weight: 700;
    font-size: toRem(16);
    color: $primaryColor;
  }
  .icon-root {
    width: toRem(24);
    border-radius: 50%;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .value {
    width: toRem(40);
    text-align: right;
    padding-right: toRem(10);
  }
}
</style>
 
